<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Awards</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Awards</h2>
      <v-spacer></v-spacer>
      <AwardExportFilter class="mr-5"></AwardExportFilter>
      <AwardCreateButton></AwardCreateButton>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <AwardTable></AwardTable>
    </div>
    <!-- Award PageTitle -->
    <div class="page-actions">
      <h2>Award PageTitle</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toEditPageTitle">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <div class="block" v-if="pageTitle != null">
      <!-- PageTitle -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ pageTitle.title }}
        </div>
      </div>
      <!-- Background -->
      <div class="form-item py-5 d-flex" v-if="false">
        <div class="w-94px mr-166px">
          <h4>Background</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center"
            :style="{
              width: '480px',
              height: '76px',
              'background-image': `url(${pageTitle.image||background})`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AwardExportFilter from '@/views/D_Awards/c/D-5__AwardExport_Filter.vue';
import AwardCreateButton from '@/views/D_Awards/c/AdwardCreateButton.vue';
import AwardTable from '@/views/D_Awards/c/AwardTable.vue';

export default {
  components: {
    AwardExportFilter,
    AwardCreateButton,
    AwardTable,
  },
  data: () => ({
    background: 'https://dummyimage.com/480x76.jpg',
  }),
  computed: {
    ...mapState('pageTitle', ['pageTitle']),
  },
  created() {
    this.clear();
    this.getAwards();
    this.getPageTitle('award');
  },
  methods: {
    ...mapActions('pageTitle', {
      getPageTitle: 'findByType',
    }),
    ...mapActions('award', {
      getAwards: 'find',
      clear: 'clear',
    }),
    toEditPageTitle() {
      this.$router.push('/awards/edit-award-page-title');
    },
  },
};
</script>

<style></style>
